import { Spaces } from '@ff-os/rendering-shared/coordinates';
import { Size } from '@ff-os/shared-utils/types/Size';

export const createMinimalPreviewSpaces = (prefabViewbox: Size): Spaces => ({

    sceneWidth: prefabViewbox.width,
    sceneHeight: prefabViewbox.height,

    designAreaX: 0,
    designAreaY: 0,
    designAreaWidth: prefabViewbox.width,
    designAreaHeight: prefabViewbox.height,

    designWidth: prefabViewbox.width,
    designHeight: prefabViewbox.height
});